// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.add-ticket-success-modal[data-v-bae48376] {\n  padding: 20px 30px 10px;\n}\n.add-ticket-success-modal__text[data-v-bae48376] {\n  margin-bottom: 20px;\n}\n.add-ticket-success-modal__text--bold[data-v-bae48376] {\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
